var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#F4FCF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 29.25H15C11.35 29.25 9.25 27.15 9.25 23.5V16.5C9.25 12.85 11.35 10.75 15 10.75H25C28.65 10.75 30.75 12.85 30.75 16.5V23.5C30.75 27.15 28.65 29.25 25 29.25ZM15 12.25C12.14 12.25 10.75 13.64 10.75 16.5V23.5C10.75 26.36 12.14 27.75 15 27.75H25C27.86 27.75 29.25 26.36 29.25 23.5V16.5C29.25 13.64 27.86 12.25 25 12.25H15Z",
    fill: "#23C965"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.75C17.93 23.75 16.25 22.07 16.25 20C16.25 17.93 17.93 16.25 20 16.25C22.07 16.25 23.75 17.93 23.75 20C23.75 22.07 22.07 23.75 20 23.75ZM20 17.75C18.76 17.75 17.75 18.76 17.75 20C17.75 21.24 18.76 22.25 20 22.25C21.24 22.25 22.25 21.24 22.25 20C22.25 18.76 21.24 17.75 20 17.75Z",
    fill: "#23C965"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.75H10C9.59 17.75 9.25 17.41 9.25 17C9.25 16.59 9.59 16.25 10 16.25H11C13.58 16.25 14.25 15.58 14.25 13V12C14.25 11.59 14.59 11.25 15 11.25C15.41 11.25 15.75 11.59 15.75 12V13C15.75 16.42 14.42 17.75 11 17.75Z",
    fill: "#23C965"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17.75H29C25.58 17.75 24.25 16.42 24.25 13V12C24.25 11.59 24.59 11.25 25 11.25C25.41 11.25 25.75 11.59 25.75 12V13C25.75 15.58 26.42 16.25 29 16.25H30C30.41 16.25 30.75 16.59 30.75 17C30.75 17.41 30.41 17.75 30 17.75Z",
    fill: "#23C965"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.75C14.59 28.75 14.25 28.41 14.25 28V27C14.25 24.42 13.58 23.75 11 23.75H10C9.59 23.75 9.25 23.41 9.25 23C9.25 22.59 9.59 22.25 10 22.25H11C14.42 22.25 15.75 23.58 15.75 27V28C15.75 28.41 15.41 28.75 15 28.75Z",
    fill: "#23C965"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28.75C24.59 28.75 24.25 28.41 24.25 28V27C24.25 23.58 25.58 22.25 29 22.25H30C30.41 22.25 30.75 22.59 30.75 23C30.75 23.41 30.41 23.75 30 23.75H29C26.42 23.75 25.75 24.42 25.75 27V28C25.75 28.41 25.41 28.75 25 28.75Z",
    fill: "#23C965"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionComplete);
export default __webpack_public_path__ + "static/media/TransactionComplete.e15cd63d2bec199c4bb6dfefb14cf958.svg";
export { ForwardRef as ReactComponent };